import { Text } from "preact-i18n";
import "../../style/Attachment.css";
import { ATTACHMENT_DOWNLOAD_CLICK } from "../../helpers/event-definitions";

const Attachment = ({ payLink, c2Analytics }) => {
  const downloadFile = async () => {
    const attachments = payLink.metadata.attachments;

    if (c2Analytics?.trackCustomEvent) {
      c2Analytics.trackCustomEvent(ATTACHMENT_DOWNLOAD_CLICK, {
        attachmentCount: attachments.length,
        isMultipleFiles: attachments.length > 1
      });
    }
    
    try {
      // Download all attachments
      for (const attachment of attachments) {
        const fileUrl = attachment.url;
        const filename = fileUrl.split('/').pop();

        const response = await fetch(fileUrl, { mode: 'cors' });
        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
        
        // Small delay between downloads to avoid overwhelming the browser
        if (attachments.length > 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  return (
    <div className='invoice-attachment'>
      <div>
        <span className='invoice-attachment-title'>
          {payLink.metadata.attachments.length > 1
          ? <Text id="INVOICE_ATTACHMENTS">Attachments</Text>
          : <Text id="INVOICE_ATTACHMENT">Attachment</Text>}
        </span>
        <br />
        {payLink.metadata.attachments.map((attachment, index) => (
          <div key={index} className='invoice-attachment-name'>
            {decodeURIComponent(attachment.url.split('/').pop() ?? '')}
          </div>
        ))}
      </div>
      <span
        className='invoice-attachment-download'
        onClick={downloadFile}
        style={{ cursor: 'pointer' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#111111" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
      </span>
    </div>
  );
};

export default Attachment;
